// One WebSocket to the server. Messages are queued until the scene subscribes.
import type { ClientMsg, ServerMsg } from '../../shared/protocol.ts';

export class Net {
  private ws: WebSocket;
  private handler: ((msg: ServerMsg) => void) | null = null;
  private queue: ServerMsg[] = [];
  onClose: ((code: number, reason: string) => void) | null = null;

  constructor() {
    const proto = location.protocol === 'https:' ? 'wss' : 'ws';
    this.ws = new WebSocket(`${proto}://${location.host}/ws`);
    this.ws.onmessage = (e) => {
      const msg = JSON.parse(String(e.data)) as ServerMsg;
      if (this.handler) this.handler(msg);
      else this.queue.push(msg);
    };
    this.ws.onclose = (e) => this.onClose?.(e.code, e.reason);
  }

  listen(fn: (msg: ServerMsg) => void): void {
    this.handler = fn;
    for (const m of this.queue.splice(0)) fn(m);
  }

  send(msg: ClientMsg): void {
    if (this.ws.readyState === WebSocket.OPEN) this.ws.send(JSON.stringify(msg));
  }
}
